import React, {useContext, useEffect, useState} from 'react'
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import ReactModal from "react-modal";
import {formatDate, getBearerToken, getServerUrl} from "./utils/utils";
import axios from "axios";
import {UserContext} from "./UserContext";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

function TagFriendsBulkModal({trips, open, onClose}) {
    const {user} = useContext(UserContext)
    const [tripsSearchValue, setTripsSearchValue] = useState("")
    const [friendsSearchValue, setFriendsSearchValue] = useState("")
    const [selectedTrips, setSelectedTrips] = useState([])
    const [friends, setFriends] = useState([])
    const [selectedFriend, setSelectedFriend] = useState(null)
    const [submitTagFriendsLoading, setSubmitTagFriendsLoading] = useState(false)
    const [selectedUserTaggedTripsObj, setSelectedUserTaggedTrips] = useState([])

    const clearState = () => {
        setTripsSearchValue("")
        setFriendsSearchValue("")
        setSelectedTrips([])
        setSelectedUserTaggedTrips([])
        setSelectedFriend(null)
        setFriends([])
    }

    const tagFriends = async () => {
        setSubmitTagFriendsLoading(true)
        axios.post(`${getServerUrl()}/tagUser/${selectedFriend}`, selectedTrips, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`,
            }
        }).then(() => {
            setSubmitTagFriendsLoading(false)
            clearState()
            onClose()
        });

    }

    const getTaggedTripsForUser = async () => {
        axios.get(`${getServerUrl()}/user/${selectedFriend}/taggedUsers`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                const selectedUserTaggedTripsObject = {}
                response.data.forEach(taggedUser => {
                    selectedUserTaggedTripsObject[taggedUser.trip.id] = taggedUser
                })
                setSelectedUserTaggedTrips(selectedUserTaggedTripsObject)
            })
    }

    const searchedTrips = !tripsSearchValue ? trips : trips.filter(trip => trip.name.toLowerCase().includes(tripsSearchValue.toLowerCase() || trip.location.toLowerCase().includes(tripsSearchValue.toLowerCase())))
    searchedTrips?.sort((a, b) => new Date(b.startDate) - new Date(a.startDate))

    const fetchFriends = async () => {
        axios.get(`${getServerUrl()}/friends`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setFriends(response.data.filter(friend => friend.status === 'ACCEPTED'))
            })
    }

    useEffect(() => {
        if (open) {
           fetchFriends()
        }

    }, [open])

    useEffect(() => {
        if (selectedFriend) {
            getTaggedTripsForUser()
        }
    }, [selectedFriend])

    return (
        <ReactModal isOpen={open} id="tag-friends-modal">
            {submitTagFriendsLoading && (
                <div className="spinner-container">
                    <CircularProgress/>
                </div>
            )}
            {!submitTagFriendsLoading && (
                <>
                    <div className="exit-button">
                        <CancelPresentationIcon sx={{fontSize: 40}} onClick={() => {
                            onClose()
                            clearState()
                        }}/>
                    </div>
                    <div className="save-ranking-list-button">
                        <Button disabled={!selectedTrips.length > 0 || !selectedFriend} variant="contained"
                                onClick={() => {
                                    tagFriends()
                                }
                                }>Save</Button>
                    </div>
                    <h2>
                        Select a friend to tag in trips
                    </h2>

                    <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        filterOptions={(x) => x}
                        options={!friendsSearchValue ? friends : friends.filter(friend => friend.friend.username.toLowerCase().includes(friendsSearchValue))}
                        getOptionLabel={friend => friend.friend.username}
                        renderInput={(params) => <TextField {...params}
                                                            label="Search by friend's name"/>}
                        onChange={(event, value) => {
                            setSelectedFriend(value.friend.id)
                        }}
                        onInputChange={(event, newInputValue) => {
                            setFriendsSearchValue(newInputValue)
                        }}
                        inputValue={friendsSearchValue}
                    />

                    <h2>
                        Select each trip you want to tag them in.
                    </h2>

                    <Autocomplete
                        id="free-solo-demo"
                        multiple
                        freeSolo
                        getOptionDisabled={option => (!!selectedUserTaggedTripsObj[option.id] || option.user.id === selectedFriend)}
                        filterOptions={(x) => x}
                        options={searchedTrips || []}
                        getOptionLabel={trip => `${trip.name} - ${trip.location} (${formatDate(trip.startDate)} - ${formatDate(trip.endDate)})`}
                        renderInput={(params) => <TextField {...params}
                                                            label="Filter by trip's name or location"/>}
                        onChange={(event, value) => {
                            setSelectedTrips(value.map(trip => trip.id))
                        }}
                        onInputChange={(event, newInputValue) => {
                            setTripsSearchValue(newInputValue)
                        }}
                        inputValue={tripsSearchValue}
                        open
                    />
                </>
            )}
        </ReactModal>
    )
}

export default TagFriendsBulkModal;